import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { PageHead, Field } from "./kit";

const EMPTY = { current_password: "", new_password: "", confirm: "" };

export default function ChangePassword() {
  const [f, setF] = useState(EMPTY);
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const type = show ? "text" : "password";
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) { toast.error("New passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password changed. Other devices have been logged out.");
      setF(EMPTY);
    } catch (x) { toast.error(errMsg(x)); }
    setBusy(false);
  };
  return (
    <div data-testid="change-password-page">
      <PageHead title="Change password" sub="Use at least 8 characters. Other devices are logged out after a change." />
      <form onSubmit={submit} className="max-w-md space-y-3 border border-white/10 bg-[#141414] p-5" data-testid="change-password-form">
        <Field label="Current password"><input required type={type} autoComplete="current-password" value={f.current_password} onChange={set("current_password")} className="field" data-testid="current-password-input" /></Field>
        <Field label="New password"><input required minLength={8} type={type} autoComplete="new-password" value={f.new_password} onChange={set("new_password")} className="field" data-testid="new-password-input" /></Field>
        <Field label="Confirm new password"><input required minLength={8} type={type} autoComplete="new-password" value={f.confirm} onChange={set("confirm")} className="field" data-testid="confirm-password-input" /></Field>
        {f.confirm && f.confirm !== f.new_password && <p className="text-xs text-red-500" data-testid="password-mismatch">Passwords do not match</p>}
        <label className="flex items-center gap-2 text-xs text-zinc-400"><input type="checkbox" checked={show} onChange={(e) => setShow(e.target.checked)} className="accent-[#C8A45D]" data-testid="change-show-password" />Show passwords</label>
        <button disabled={busy} className="btn-gold w-full" data-testid="change-password-submit">{busy ? "Saving…" : "Change password"}</button>
      </form>
    </div>
  );
}
